module.exports = __webpack_public_path__ + "static/media/for_todolist_site_full.37d02d3f.png";